export const routeNames = {
  EMAIL_AND_INVOICE: 'email',
  INVOICE_CONFIRM: 'invoice/confirm',
  LEQ_SUMMARY: 'leq-summary',
  LEQ: 'leq',
  SELECT_INSTALLMENT_PLAN: 'term-select',
  BANK_TRANSFER_FRAME: 'transfer',
  SETTLE: 'settle',
  SUCCESS: 'success',
  AUTH: 'auth',
  ERROR: 'error',
  PERSONAL_NUMBER_ENTRY: 'pnr-entry',
  HOME: '',
  SWISH: 'swish',
  TRUSTLY_DIRECT_DEBIT: 'direct-debit',
  TRUSTLY_DIRECT_DEBIT_EMAIL: 'tdd-landing-email',
  FINSHARK: 'finshark',

  //LOAN CALCULATOR
  LOAN_CALCULATOR: 'loan-calculator',
};

export const routeParamNames = {
  TASK_ID: 'task',

  //LOAN CALCULATOR
  LOCALE: 'locale',
  QR_CODE: 'code',
};

export enum AtRoute {
  HOME = 'at',
  EMAIL_AND_PHONE_REGISTRATION = 'at/email-and-phone-registration',
  PHONE_VERIFICATION = 'at/phone-verification',
  USER_REGISTRATION = 'at/user-registration',
  PRE_FTS = 'at/pre-fts',
  FTS = 'at/fts',
  FINAPI = 'at/finapi',
  FINAPI_PAYMENT = 'at/finapi-payment',
  PRE_FINAPI = 'at/pre-finapi',
  FINAPI_UPDATE = 'at/finapi-update',
  PART_SUCCESS = 'at/part-success',
  VERIFY_USER = 'at/verify-user',
  SUCCESS = 'at/success',
  RESTORE_ACCOUNT = 'at/account-restoration',
  EDIT_PHONE = 'at/edit-phone',
  ERROR = 'at/error',
  REJECTED = 'at/rejected',
  VERIFY_EMAIL = 'at/verify-email',
  PRECHECK = 'at/precheck',
  CONFIRM_TOKENIZED_PAYMENT = 'at/confirm-charge',
  INSTALLMENTS_SELECTION = 'at/installments-selection',
  CONFIRM_COLLECTIVE_INVOICE = 'at/confirm-collective-invoice',
  SELECT_IBAN = 'at/select-iban',
  REGISTER_IBAN = 'at/register-iban',
}

export enum DeRoute {
  HOME = 'de',
  EMAIL_AND_PHONE_REGISTRATION = 'de/email-and-phone-registration',
  PHONE_VERIFICATION = 'de/phone-verification',
  USER_REGISTRATION = 'de/user-registration',
  PRE_FTS = 'de/pre-fts',
  FTS = 'de/fts',
  FINAPI = 'de/finapi',
  FINAPI_PAYMENT = 'de/finapi-payment',
  PRE_FINAPI = 'de/pre-finapi',
  FINAPI_UPDATE = 'de/finapi-update',
  PART_SUCCESS = 'de/part-success',
  VERIFY_USER = 'de/verify-user',
  SUCCESS = 'de/success',
  RESTORE_ACCOUNT = 'de/account-restoration',
  EDIT_PHONE = 'de/edit-phone',
  ERROR = 'de/error',
  REJECTED = 'de/rejected',
  VERIFY_EMAIL = 'de/verify-email',
  PRECHECK = 'de/precheck',
  CONFIRM_TOKENIZED_PAYMENT = 'de/confirm-charge',
  INSTALLMENTS_SELECTION = 'de/installments-selection',
  CONFIRM_COLLECTIVE_INVOICE = 'de/confirm-collective-invoice',
  SELECT_IBAN = 'de/select-iban',
  REGISTER_IBAN = 'de/register-iban',
}

export enum FiRoute {
  HOME = 'fi',
  AUTHENTICATE = 'fi/authenticate',
  AUTHENTICATE_SCRIVE = 'fi/authenticate-scrive',
  EMAIL_AND_PHONE_REGISTRATION = 'fi/email-and-phone-registration',
  CONFIRM_INVOICE = 'fi/invoice/confirm',
  INSTALLMENTS_SELECTION = 'fi/installments-selection',
  SUCCESS = 'fi/success',
  ERROR = 'fi/error',
  REJECTED = 'fi/rejected',
  BASE_KALP_FI = 'fi/leq',
  EXTENDED_KALP_FI = 'fi/leq-extended',
  KALP_REVIEW_ANSWERS = 'fi/leq-review',
}

export enum NoRoute {
  HOME = 'no',
  EMAIL_REGISTRATION = 'no/email',
  SALARY_CHECK = 'no/salary-check',
  CONFIRM_INVOICE = 'no/invoice/confirm',
  INSTALLMENTS_SELECTION = 'no/installments-selection',
  SUCCESS = 'no/success',
  NO_BANKID = 'no/auth',
  ERROR = 'no/error',
  REJECTED = 'no/rejected',
  PERSONAL_NUMBER_ENTRY = 'no/pnr-entry',
  NO_VIPPS = 'no/vipps',
  KALP = 'no/leq',
  KALP_REVIEW_ANSWERS = 'no/leq-review',
}

export enum SeRoute {
  PRECHECK = 'se/precheck',
  AUTHENTICATE = 'se/authenticate',
  BANK_MANDATE = 'se/bank-mandate',
  SE_BANK_START = 'se/connect-to-bank-start',
  SELECT_AIS_ACCOUNT = 'se/ais-account',
  SELECT_AIS_CALLBACK = 'se/ais-callback',
  EMAIL_AND_PHONE_REGISTRATION = 'se/email-and-phone-registration',
  CONFIRM_IN_HOUSE_ONBOARDING = 'se/confirm-onboarding',
  CONFIRM_TOKENIZED_PAYMENT = 'se/confirm-payment',
  CONFIRM_IN_HOUSE_INSTANT_DEBIT = 'se/confirm-instant-debit',
  SUCCESS = 'se/success',
  ERROR = 'se/error',
  REJECTED = 'se/rejected',
  HOME = 'se',
  TRANSITION = 'se/transition',
  VENDOR_FLOW = 'se/vendor-flow',
  CONFIRM_TOKENIZED_ONBOARDING_INVOICE = 'se/confirm-onboarding-invoice',
  BANK_ID_SIGN = 'se/sign',
  PIA_EMAIL_AND_PHONE_REGISTRATION = 'se/pia-email-and-phone-registration',
  PIA_VERIFY_EMAIL = 'se/pia-verify-email',
  PIA_PHONE_VERIFICATION = 'se/pia-phone-verification',
  KREDITZ = 'se/kreditz',
}
